import React from "react";


export default function Footer() {
  return (
    <footer id="footer">
      <div className="linkContainer flexBox center-center">
        <div className="column">
          <a href="https://www.media4care.de/impressum/"
             rel="noopener noreferrer"
             target="_blank">{__("Imprint")}</a>
          <a href="https://www.media4care.de/datenschutz/"
             rel="noopener noreferrer"
             target="_blank">{__("Data protection")}</a>
        </div>
      </div>
      <div className="copyright description">
        <i className="fa fa-copyright"/>Media4Care
      </div>
    </footer>
  );
}
